<div class="mc-comment-box-container">
  <mat-form-field mcColor="secondary">
    <mat-label *ngIf="isReplyText || isNewComment">
      {{isReplyText ? 'Add reply' : isNewComment ? 'Add new comment' : ''}}
    </mat-label>
    <textarea #textArea class="mc-comment-box-input" matInput rows="{{isNewComment === false? 1 : reduceSize ? 2 : 3}}" cols="40" [(ngModel)]="comment.Comment" placeholder="{{isReplyText ? 'Add reply' : isNewComment ? 'Add new comment' : ''}}" [disabled]="!canEditAllTasks" (input)="onInputChanged()"></textarea>

    <input #fileInput class="mc-hidden" multiple="multiple" type="file" (change)="onAddAttachmentsChanged($event)">
    <mat-icon *ngIf="canEditAllTasks" matIconSuffix class="mc-link" [fontSet]="'project-titan'" [fontIcon]="'icon-attach'" (click)="fileInput.click()"></mat-icon>

  </mat-form-field>
</div>
<div [ngClass]="{'mc-comment-box-assets-container': isNewComment}">
  <mc-task-asset *ngFor="let commentAsset of comment.TaskAssets" [asset]="commentAsset" (delete)="onAssetDelete($event)" [canEditAllTasks]="canEditAllTasks"></mc-task-asset>
</div>